const themes = {
    default: {
        colors: {
            primary: '#152E3B',
            secondary: '#3CACBB'
        },
        menu: {
            border: '#D4D6D6',
            selected: '#F4D345',
            text: '#152E3B'
        },
        logo: ''
    }
}

export default themes
